import Repository from './repository'

const resource = '/avaliacao-postural'

export default {
  PosturalGetById (id) {
    return Repository.get(`${resource}/${id}`)
  },
  PosturalGetByAssessmentId (id) {
    return Repository.get(`${resource}/assessment/${id}`)
  },
  PosturalGet () {
    return Repository.get(`${resource}`)
  },
  PosturalPost (item) {
    return Repository.post(`${resource}`, item, { headers: { 'Content-Type': 'multipart/form-data' } })
  },
  PosturalPut (id, item) {
    // O PHP nao popula $_POST/$_FILES em requisicoes PUT com multipart/form-data:
    // o corpo chega vazio, o update roda sem dados e ainda responde sucesso.
    // Usa POST com method spoofing do Laravel (_method=PUT), que e a forma
    // suportada para enviar arquivos em atualizacoes.
    item.append('_method', 'PUT')
    return Repository.post(`${resource}/${id}`, item, { headers: { 'Content-Type': 'multipart/form-data' } })
  },
  PosturalDelete (id) {
    return Repository.delete(`${resource}/${id}`)
  }
}
